<section id="bdm-news-overview-container">
  <div id="bdm-news-outer-container">
    <article class="bdm-news" *ngFor="let news of newsList">
      <h1 class="news-title">{{news.title}}</h1>
      <pre class="news-message">{{news.message}}</pre>
      <img class="news-image" *ngFor="let image of news.downloadedImages" src="data:image/jpeg;base64,{{image}}" alt="">
      <p class="news-date">News vom {{news.date}}</p>
    </article>
  </div>
</section>
